module.exports = __webpack_public_path__ + "img/2.9073ab0.9073ab0c.png";